module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inputType":"Input type","items":"Items","run":"Run immediately"}}')
  delete Component.options._Ctor
}
